import { proxy, subscribe } from 'valtio';
import Task from './Task';
import { hydrateFromObject } from '../../lib/utils/hydrate';
import { TaskState } from './types';

export type TasksState = {
  version: number;
  tasks: Record<string, Task>;
};

export const readStateTasks = (): Record<string, Task> | null => {
  const state = localStorage.getItem('tasks');
  if (state) {
    const parsedTasks = JSON.parse(state);
    const resultTasks: Record<string, Task> = {};

    // hydrate tasks
    Object.keys(parsedTasks).forEach((key) => {
      const isExternalCallAccepted =
        parsedTasks[key]._state === TaskState.Accepted &&
        !parsedTasks[key]._isInternal;

      // set all accepted external calls to wrap up
      if (isExternalCallAccepted) {
        parsedTasks[key]._state = TaskState.WrapUp;
        parsedTasks[key]._wrapUpStartedAt = Date.now();
      }

      const hydratedTask = hydrateFromObject(
        Task,
        parsedTasks[key],
        undefined,
        [{}],
      );

      const isInternalAccepted =
        hydratedTask.state === TaskState.Accepted && hydratedTask.isInternal;

      // ignore any tasks that are in OFFERED state or internal calls that are accepted
      if (hydratedTask.state !== TaskState.Offered && !isInternalAccepted) {
        resultTasks[key] = hydratedTask;
      }
    });

    return resultTasks;
  }
  return null;
};

export const tasksState = proxy<TasksState>({
  version: 0,
  tasks: readStateTasks() || {},
});

subscribe(tasksState, () => {
  localStorage.setItem('tasks', JSON.stringify(tasksState.tasks));
});

export function setMockedTasks(tasks: Task[]) {
  const tasksMap: Record<string, Task> = {};
  tasks.forEach((task) => (tasksMap[task.id] = task));
  tasksState.tasks = tasksMap;
}
